export var QueryKeys = /*#__PURE__*/ function(QueryKeys) {
    QueryKeys["LegalTerms"] = "LegalTerms";
    QueryKeys["Relationship"] = "Relationship";
    QueryKeys["Draft"] = "Draft";
    QueryKeys["ArchivedProposals"] = "ArchivedProposals";
    QueryKeys["CanResyncQbo"] = "CanResyncQbo";
    QueryKeys["CanResyncXero"] = "CanResyncXero";
    QueryKeys["ServiceTemplatesForBilling"] = "ServiceTemplatesForBilling";
    QueryKeys["Contacts"] = "Contacts";
    QueryKeys["ContactsMap"] = "ContactsMap";
    QueryKeys["ActiveServices"] = "ActiveServices";
    QueryKeys["ProposalTemplates"] = "ProposalTemplates";
    QueryKeys["ServiceBillingDetails"] = "ServiceBillingDetails";
    QueryKeys["GetInfo"] = "getInfo";
    QueryKeys["PromptSuggestions"] = "PromptSuggestions";
    QueryKeys["RichText"] = "RichText";
    QueryKeys["PdfUrl"] = "PdfUrl";
    QueryKeys["BillingSchedule"] = "BillingSchedule";
    QueryKeys["UserReferral"] = "UserReferral";
    QueryKeys["PayoutsSummary"] = "PayoutsSummary";
    QueryKeys["SalesSummary"] = "SalesSummary";
    QueryKeys["HistoricAgreementStats"] = "HistoricAgreementStats";
    QueryKeys["MonthlyEarnings"] = "MonthlyEarnings";
    QueryKeys["HistoricRevenueStats"] = "HistoricRevenueStats";
    QueryKeys["InvoicesDigest"] = "InvoicesDigest";
    QueryKeys["Proposals"] = "Proposals";
    QueryKeys["Drafts"] = "Drafts";
    QueryKeys["ActivityLog"] = "ActivityLog";
    QueryKeys["CustomPageTemplates"] = "CustomPageTemplates";
    QueryKeys["CustomPageText"] = "CustomPageText";
    QueryKeys["CustomPageDownloadUrl"] = "CustomPageDownloadUrl";
    QueryKeys["Invoice"] = "Invoice";
    QueryKeys["InvoiceDashboardPreferences"] = "InvoiceDashboardPreferences";
    QueryKeys["InvoiceMetrics"] = "InvoiceMetrics";
    QueryKeys["NotificationSettings"] = "NotificationSettings";
    QueryKeys["PayoutInvoices"] = "PayoutInvoices";
    QueryKeys["Agreements"] = "Agreements";
    QueryKeys["QboClasses"] = "QboClasses";
    QueryKeys["QboItems"] = "QboItems";
    QueryKeys["XeroItems"] = "XeroItems";
    QueryKeys["QboCustomers"] = "QboCustomers";
    QueryKeys["XeroCustomers"] = "XeroCustomers";
    QueryKeys["TeamInvites"] = "TeamInvites";
    QueryKeys["ServiceTemplates"] = "ServiceTemplates";
    QueryKeys["ServiceTemplateBundles"] = "ServiceTemplateBundles";
    QueryKeys["QboTimeActivities"] = "QboTimeActivities";
    QueryKeys["PersonaKYBStatus"] = "PersonaKYBStatus";
    QueryKeys["TasksJobs"] = "TasksJobs";
    QueryKeys["InvoiceDraftDates"] = "InvoiceDraftDates";
    QueryKeys["AdHocScheduledData"] = "AdHocScheduledData";
    return QueryKeys;
}({});
